function getLiftCoreCost(state, props) {
  const liftCoreCost = state.liftCoreCount === props.targetLiftCoreCount ? 0 : 1e6;
  return liftCoreCost;
}
export {
  getLiftCoreCost
};
//# sourceMappingURL=index206.js.map
